'use client'

import dynamic from 'next/dynamic'

// This wrapper component prevents SSR for FreeTrialEligibleAgain
// In Next.js 15, ssr: false is not allowed in Server Components,
// so we use this client component wrapper with dynamic import instead
export const FreeTrialEligibleAgainClient = dynamic(
  () => import('./index').then(mod => mod.FreeTrialEligibleAgain),
  {
    ssr: false,
    loading: () => null,
  },
)
